// Vendor plugins
require('../plugins');

// Import vue
import CKEditor from '@ckeditor/ckeditor5-vue2';
import BootstrapVue, { BootstrapVueIcons } from 'bootstrap-vue';
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import IdleVue from "idle-vue";
import SvgVue from 'svg-vue';
import VCalendar from 'v-calendar';
import VueMask from 'v-mask';
import money from "v-money";
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import ToggleButton from 'vue-js-toggle-button';
import Loading from 'vue-loading-overlay';
import Meta from 'vue-meta';
import vSelect from 'vue-select';
import VueSnackbar from 'vue-snack';
import VueTextareaAutosize from 'vue-textarea-autosize';
import Vuex from 'vuex';
import arrays from './arrays';
import cid from './cid';
import i18n from './language';
import ocupacao from './ocupacao';
import router from './router';
import store from './stores/store';
import agendamentosStore from "./stores/agendamentosStore";
import agendaAtivaStore from "./stores/agendaAtivaStore";
import historicoAtendimentoStore from "./stores/historicoAtendimentoStore";
// Import Sentry
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import InputColorPicker from "vue-native-color-picker";


import Vue2Editor from "vue2-editor";

import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

import Chart from 'chart.js';
import Chartkick from 'vue-chartkick';
import VueHtml2Canvas from 'vue-html2canvas';
import InputTag from 'vue-input-tag';

import vueFilterPrettyBytes from 'vue-filter-pretty-bytes';

import 'animate.css';

import 'bootstrap/dist/js/bootstrap.bundle.min.js';
window.bootstrap = require('bootstrap');

// Configure Sentry
if (window.config.sentry_dsn) {
    Sentry.init({
        dsn: window.config.sentry_dsn,
        integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    });
}
const eventsHub = new Vue();

Vue.use(Chartkick.use(Chart))
Vue.component('input-tag', InputTag)
Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store,
    idleTime: 60000,
    startAtIdle: false
});
//30000 = .5 minute
//60000 = 1 minute
//180000 = 3 minute
Vue.use(VueLodash, { lodash: lodash })
Vue.use(InputColorPicker);
Vue.use(CKEditor);
Vue.use(VCalendar, { componentPrefix: 'v' });
// Vue declarations
Vue.use(Vuex);
Vue.use(Meta);
Vue.use(SvgVue);
Vue.use(BootstrapVue);
Vue.use(ToggleButton);
Vue.use(VueClipboard);
Vue.use(VueTextareaAutosize);
Vue.use(VueMask);
Vue.use(VueHtml2Canvas);
Vue.component('loading-animation', Loading);
Vue.component('v-select', vSelect)
Vue.use(VueSnackbar, { position: 'bottom', time: 5000 });
Vue.use(money, {
    precision: 4
});
Vue.use(BootstrapVueIcons);
Vue.component('VueSlider', VueSlider)

const moment = require('moment')
require('moment/locale/pt-br')

Vue.use(require('vue-moment'), {
    moment
})

Vue.use(vueFilterPrettyBytes);


// Vue components
require('./components');

require('./filtros');

window.bus = new Vue();
window.urlbase = `${window.location.protocol}//${window.location.host}/`;

require('./mixins');

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyBxPpJtZmFLNSTlxKbsrfncWW4MjENWp1w",
        libraries: 'places,drawing,visualization',
        region: "en,pt-BR"
    }
});

Vue.use(Vue2Editor);
// Define vue
new Vue({
    el: '#app',
    router,
    store,
    provide: {
      agendamentosStore,
      agendaAtivaStore,
      historicoAtendimentoStore
    },
    i18n,
    arrays,
    ocupacao,
    data() { return { arrays: arrays, ocupacoes: ocupacao, cid: cid } },
    mounted() {
        this.initi18n();
        this.$store.commit('setUser');
        this.$store.commit('setSettings', window.config);
        if (localStorage.getItem("token_suporte")) {
            this.$store.dispatch("setLoginSuporte");
        }

    },
    methods: {
        verifyNull(item) {
            return typeof item !== 'undefined' ? item : null;
        },
        // Start the translations vue-i18n
        initi18n() {
            this.$i18n.locale = document.documentElement.lang;

            this.loadTranslations();
        },
        // Get translations of a specific language
        loadTranslations() {
            axios.get('api/lang/' + this.$i18n.locale).then((response) => {
                this.$i18n.setLocaleMessage(this.$i18n.locale, response.data.data);
            });
        },
        redirectProntuario(familia_id) {
            swal.fire({
                title: "Aguarde",
                text: "Redirecionando para o prontuario da familia",
                imageUrl: `${window.urlbase}/img/load.svg`,
                showConfirmButton: false,
                timer: 2000,
            });
            this.$router.push(
                `/dashboard/familias/edit/${familia_id}`
            );
        }, redirectAcompanhamento(familia_id) {
            swal.fire({
                title: "Aguarde",
                text: "Redirecionando para o prontuario da familia",
                imageUrl: `${window.urlbase}/img/load.svg`,
                showConfirmButton: false,
                timer: 2000,
            });
            this.$router.push({
                path: `/dashboard/acompanhamentos/${familia_id}`,
                query: { familia_id: familia_id },
            });
        }, redirectMedidas(familia_id) {
            this.$router.push({
                path: `/dashboard/medidas/${familia_id}`,
                query: { familia_id: familia_id },
            });
        }, redirectViolacaoDireito(familia_id) {
            this.$router.push({
                path: `/dashboard/violacaodedireitos/${familia_id}`,
                query: { familia_id: familia_id },
            });
        },
    },
    computed: {
        isIdle() {
            return this.$store.state.idleVue.isIdle;
        },
    }
});



if (window.urlbase != 'https://sandbox.suasfacil.com.br' && window.urlbase != 'http://suasfacil.host/' && window.urlbase != 'https://suasfacil.host/' && window.urlbase != 'http://suasfacil.localhost/') {
    Vue.config.productionTip = false;
    Vue.config.devtools = false
    Vue.config.debug = false
    Vue.config.silent = true
}

